'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M0 160l128 0 0-64c0-53 43-96 96-96s96 43 96 96l0 64 128 0 0 64-288 0 0 256L0 480 0 160zM176 96l0 64 96 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48zM288 320l32 0 0 16 0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16 0-16 32 0 0 16 0 16c0 53-43 96-96 96s-96-43-96-96l0-16 0-16z', 'M576 256l-384 0 0 256 384 0 0-256zM320 336l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16 0-16 32 0 0 16 0 16c0 53-43 96-96 96s-96-43-96-96l0-16 0-16 32 0 0 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;